// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37ic-","title":"Header_title__2Sm16","side":"Header_side__JdyfM"};